query getUserPreferencesForCurrentUser {
  preferences: getUserPreferencesForCurrentUser {
    userId
    scope
    createdAt
    updatedAt
    preferences
  }
}

mutation updateUserPreferencesForCurrentUser(
  $preferences: [UserPreferencesUpdate!]!
) {
  preferences: updateUserPreferencesForCurrentUser(preferences: $preferences) {
    userId
    scope
    createdAt
    updatedAt
    preferences
  }
}
